import Signal from '@signals/Signal.js';

// Signal for when AI selection mode is toggled
export const aiSelectionModeChanged = new Signal();

// Signal for AI selection actions (export to tasks/projects)
export const aiSelectionActionChanged = new Signal();

// Signal for AI view changes
export const aiViewChange = new Signal();
